import * as React from 'react';
import { TextField, ListSubheader } from '@material-ui/core';
import Autocomplete, {
  createFilterOptions,
} from '@material-ui/lab/Autocomplete';
import { FormattedMessage } from 'react-intl';
import {
  OPTIONS_LIMIT,
  readHistory,
  pushHistory,
  resolveOption,
  buildFilterOptions,
} from '../../helpers/filter-options';

const defaultFilter = createFilterOptions({ limit: OPTIONS_LIMIT });

const RECENT_GROUP = 'recent';
const OTHERS_GROUP = 'others';

const groupBy = option => (option.recent ? RECENT_GROUP : OTHERS_GROUP);

// Only the recent group gets a header; the rest of the list has none.
const renderGroup = params =>
  params.group === RECENT_GROUP ? (
    <li key={params.key}>
      <ListSubheader component="div">
        <FormattedMessage id="Recent" />
      </ListSubheader>
      <ul style={{ padding: 0 }}>{params.children}</ul>
    </li>
  ) : (
    <React.Fragment key={params.key}>{params.children}</React.Fragment>
  );

// Autocomplete controlled by id: the selected option is derived from `value`
// (an id, string or number, or '') on every render, so it survives Formik
// reinitialization and options arriving after the value.
const FilterAutocomplete = ({
  name,
  label,
  options,
  value,
  onChange,
  getOptionLabel,
  historyField,
  loading,
}) => {
  const filterOptions = buildFilterOptions(
    defaultFilter,
    readHistory(localStorage, historyField)
  );

  return (
    <Autocomplete
      id={`filter-autocomplete-${name}`}
      options={options}
      value={resolveOption(options, value)}
      getOptionLabel={getOptionLabel}
      getOptionSelected={(option, selected) => option.id === selected.id}
      onChange={(e, selected) => {
        onChange(selected ? selected.id : '');

        if (selected) {
          pushHistory(localStorage, historyField, selected.id);
        }
      }}
      filterOptions={filterOptions}
      groupBy={groupBy}
      renderGroup={renderGroup}
      loading={loading}
      noOptionsText={<FormattedMessage id="No options" />}
      loadingText={<FormattedMessage id="Loading..." />}
      openOnFocus
      clearOnEscape
      renderInput={params => (
        <TextField
          {...params}
          name={name}
          label={label}
          margin="dense"
          fullWidth
        />
      )}
    />
  );
};

export default FilterAutocomplete;
